module.exports = __webpack_public_path__ + "static/20230619_056-3697ae5035233c5facd1ed160a01fa39.jpg";